import { Button } from '@thanx/uikit/button'
import { Modal } from '@thanx/uikit/modal'
import { alert } from 'actions/flash'
import { getLocationCategories } from 'actions/locationCategory'
import useDispatch from 'hooks/useDispatch'
import { buildTranslate } from 'locales'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { selectLocationCategoriesById } from 'selectors/locationCategory'

type Props = {
  isOpen: boolean
  onClose?: () => void
  onEdit?: () => void
  categoryIds: number[]
}

const translate = buildTranslate(
  'thanx_campaigns.review.customers.categoryModal'
)

const CategoryListModal: React.FC<Props> = props => {
  const { isOpen, onClose, onEdit, categoryIds } = props

  const dispatch = useDispatch()
  const categories = useSelector(state =>
    selectLocationCategoriesById(state, categoryIds)
  )

  useEffect(() => {
    async function fetchCategories() {
      const action = await dispatch(getLocationCategories())
      if (action.error) {
        dispatch(
          alert({
            key: 'danger',
            message: I18n.t('thanx_campaigns.review.get_metrics_error'),
          })
        )
      }
    }

    fetchCategories()
  }, [dispatch])

  function onEditHandler() {
    if (onEdit) onEdit()
    if (onClose) onClose()
  }

  if (categoryIds.length === 0) return null

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="fs-unmask p-m mt-l">
        <h5 className="mb-l">{translate('title')}</h5>
        <div className="body-text-2 grey-70 px-m mb-m">
          {categories.map(category => (
            <div key={category.id}>{category.title}</div>
          ))}
        </div>
        <div className="d-flex justify-content-between">
          <Button
            onClick={onEditHandler}
            className="flex-grow-1 mr-s"
            kind="secondary"
          >
            {translate('editButton')}
          </Button>
          <Button className="flex-grow-1" onClick={onClose}>
            {translate('confirmButton')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default CategoryListModal
